import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import { sanitizeNumber } from '../../lib/Sanitizer';

const Context = React.createContext();

export const BranchOfficeProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `BranchOffice/${props.officeId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `BranchOffice/Franchise/${props.franchiseId}`, method: 'POST', payload: sanitizeData(props), multipart: true, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `BranchOffice/${props.officeId}`, method: 'PUT', payload: sanitizeData(props), multipart: true, secure: true });
    }, [execute]);

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `BranchOffice/Franchise/${props.franchiseId}?overrideCache=true`, method: 'GET', secure: true });
    }, [execute]);

    const listAllRecords = useCallback(async (props) => {
        await execute({ scope: 'listAll', url: `BranchOffice/`, method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `BranchOffice/${props.officeId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const deletePhoto = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `BranchOffice/DeletePhoto/${props.id}/${props.isMainPhoto}`, method: 'DELETE', secure: true });
    }, [execute]);

    const geocodeRecord = useCallback(async (props) => {
        await execute({ scope: 'geocode', url: `BranchOffice/UpdateGeocode/${props.officeId}`, method: 'PUT', secure: true });
    }, [execute]);

    const branchOfficeData = useCallback(async () => {
        await execute({ scope: 'selectDropdownBranchOfficeData', url: `BranchOffice/GetBranchOfficeData`, method: "GET", secure: true });
    }, [execute]);

    const franchiseAgents = useCallback(async (props) => {
        await execute({ scope: 'getFranchiseAgents', url: `BranchOffice/GetFranchiseAgents/${props.franchiseId}`, method: "GET", secure: true });
    }, [execute]);

    const BranchOfficesForDashboard = useCallback(async (props) => {
        await execute({ scope: 'BranchOfficesForDashboard', url: `BranchOffice/GetBranchOfficesForDashboard/`, method: "GET", secure: true });
    }, [execute]);


    const sanitizeData = (value) => {
        if (value) {
            value.monthlyRent = (value.monthlyRent) && sanitizeNumber(value.monthlyRent);
            value.expenses = (value.expenses) && sanitizeNumber(value.expenses);
            value.pricePerSqFt = (value.pricePerSqFt) && sanitizeNumber(value.pricePerSqFt);
            value.sqFt = (value.sqFt) && sanitizeNumber(value.sqFt);
        }
        return value;
    };

    const value = { selectRecord, listRecords, listAllRecords, newRecord, deleteRecord, deletePhoto, updateRecord, createRecord, branchOfficeData, geocodeRecord, data, clearData, franchiseAgents, BranchOfficesForDashboard };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useBranchOfficeStore = () => React.useContext(Context);
